export default __webpack_public_path__ + "static/media/bg-masthead-1-480w.883d2542.jpg";